module.exports = __webpack_public_path__ + "static/media/alex-silly.6db494f0.jpg";